type PageObject = {
  name: string
  description: string
}

type ImpactModulePages = {
  [key: string]: PageObject
}

export const ASSESSMENTS_AND_RESEARCH_PAGES: ImpactModulePages = {
  SURVEY: {
    name: 'Pesquisas',
    description: 'Gestão das pesquisas',
  },
  GROUP_MODULE_PERMISSION: {
    name: 'Permissões de grupo',
    description: 'Gestão das permissões de grupos',
  },
  PUBLIC_AGENT_MODULE_PERMISSION: {
    name: 'Permissões de agentes',
    description: 'Gestão das permissões dos agentes',
  },
  SURVEY_REGISTRATION: {
    name: 'Registro de pesquisa',
    description: 'Registro de pesquisas por terceiros',
  },
}
